import { message } from 'antd';
import { configureLoggers, types, levels } from '@efsa/dlw-logger';
import {
  configureAuthenticator,
  OAuthVersion,
} from '@efsa/dlw-authenticator';

const loggers = [{ type: types.CONSOLE, minimumLogLevel: levels.INFO }];

const { serverConfig = {} } = window;
const { Authentication = {} } = serverConfig;

if (Authentication && Authentication.ClientId && Authentication.TenantId) {
  configureAuthenticator({
    clientId: Authentication.ClientId,
    tenant: Authentication.TenantId,
    oAuthVersion: OAuthVersion.V1,
  });
} else {
  message.error('Authentication configuration data is missing.');
}

configureLoggers(loggers);
